var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"about-content",domProps:{"innerHTML":_vm._s(_vm.about)}},[_vm._v(_vm._s(_vm.about))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }